<template>
  <div class="header-top-inner">
    <button class="btn-side" @click.prevent="showLnbMenu">
      <span class="a11y-hidden">주요 서비스 메뉴 펼치기</span>
      <span class="icon-side">
        <MenuButton/>
      </span>
    </button>
    <div :class="getLogoClass">
        <router-link :to="{ name: 'home' }">
          <Logo v-if="!isPooqZone"/>
          <PooqZoneLogo v-if="isPooqZone"/>
        </router-link>
    </div>
    <button class="btn-search" @click.prevent="showSlideSearch">
      <span class="a11y-hidden">검색</span>
      <span class="icon-search">
        <SearchButton />
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import MenuButton from '@/assets/svg/common/ic_gnb_menu_w.svg'
import SearchButton from '@/assets/svg/common/ic_gnb_search_w.svg'
import Logo from '@/assets/svg/logo/logo.svg'
import PooqZoneLogo from '@/assets/svg/logo/pooqzone.svg'

export default {
  name: 'MainHeader',
  data () {
    return {
      logoComponent: null
    }
  },
  components: {
    MenuButton,
    SearchButton,
    Logo,
    PooqZoneLogo
  },
  computed: {
    ...mapGetters(['isPooqZone']),
    getLogoClass () {
      return !this.isPooqZone ? 'logo normal' : 'logo pooqzone'
    }
  },
  methods: {
    ...mapMutations({ showLnb: 'showLnb',
      setBeforeOpenMenu: 'setBeforePathOpenMyPooq',
      resetSearchState: 'resetSearchState' }),
    showSlideSearch () {
      this.resetSearchState()
      this.$router.push('/search')
    },
    showLnbMenu () {
      this.setBeforeOpenMenu(this.$route.fullPath)
      this.showLnb()
    }
  },
  mounted () {
    this.logoComponent = () => !this.isPooqZone ? Logo : PooqZoneLogo
  }
}
</script>
